module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Edit-68161730a18f8c8fdc09b858d677b8f6.svg";